
const apiCalls = {
    "loginUser": "auth/login",
    "logoutUser": "auth/logout",
    "loginChangePassword": "auth/loginChangePassword",
    "MenuList": "menus",
    "Settings": "settings",
    "LocationImagePath": "uploads?uploadWhileCreate=true&uploadPath=location",
    "ProfileImagePath": "uploads?uploadWhileCreate=true&uploadPath=employee",
    "dashboard": "dashboard/counts",
    "Provideremployee": "provideremployees",
    "Provideremployees": "provideremployees",
    "Providers": "providerss",
    "Providerss": "providerss",
    "Facilities": "facilitiess",
    "Facilitiess": "facilitiess",
    "Patients": "patientss",
    "Patientss": "patientss",
    "Orders": "orderss",
    "Orderss": "orderss",
    "Uploads": "bulkuploadStatus"
  }
export default apiCalls;
